module.exports = __webpack_public_path__ + "img/section-02@3x.cfb06ba5.png";